var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "currentColor",
    opacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.25C16.1519 9.25 12.625 12.7769 12.625 17.125C12.625 23.0312 20.5 31.75 20.5 31.75C20.5 31.75 28.375 23.0312 28.375 17.125C28.375 12.7769 24.8481 9.25 20.5 9.25ZM20.5 19.9375C18.9475 19.9375 17.6875 18.6775 17.6875 17.125C17.6875 15.5725 18.9475 14.3125 20.5 14.3125C22.0525 14.3125 23.3125 15.5725 23.3125 17.125C23.3125 18.6775 22.0525 19.9375 20.5 19.9375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconBig);
export default __webpack_public_path__ + "static/media/LocationIconBig.e0e0a12c4d799f056279e8299cc2f8db.svg";
export { ForwardRef as ReactComponent };